import SolidityContract from '@exodus/solidity-contract'
import assert from 'minimalistic-assert'

import * as ErrorWrapper from './error-wrapper.js'
import { fetchGasLimit } from './gas-estimation.js'

export const getNftArguments = async ({ asset, nft, fromAddress, toAddress }) => {
  assert(asset, 'asset is required')
  assert(nft, 'nft is required')
  assert(fromAddress, 'fromAddress is required')
  assert(toAddress, 'toAddress is required')
  const { contractAddress, tokenId, contractType } = nft

  const txInputs = []

  if (!contractType || contractType === 'erc1155') {
    const txInput = `0x${SolidityContract.simpleErc1155(contractAddress)
      .safeTransferFrom.build(fromAddress, toAddress, tokenId, 1, [])
      .toString('hex')}`
    txInputs.push({ txInput, contractType: 'erc1155' })
  }

  if (!contractType || contractType === 'erc721') {
    const txInput = `0x${SolidityContract.simpleErc721(contractAddress)
      .safeTransferFrom.build(fromAddress, toAddress, tokenId)
      .toString('hex')}`
    txInputs.push({ txInput, contractType: 'erc721' })
  }

  const errors = [`Cannot fetch gas for ${asset.name}`]
  const { txInput, gasLimit } = await Promise.any(
    txInputs.map(async ({ txInput, contractType }) => {
      try {
        const gasLimit = await fetchGasLimit({
          asset,
          fromAddress,
          toAddress: contractAddress,
          txInput,
          amount: asset.baseAsset.currency.ZERO,
        })
        return { txInput, gasLimit }
      } catch (e) {
        errors.push(`ContractType ${contractType} nft input ${txInput}. ${e.message}`)
        throw e
      }
    })
  ).catch((e) => {
    throw new ErrorWrapper.EthLikeError({
      message: errors.join('\n'),
      reason: ErrorWrapper.reasons.fetchGasLimitFailed,
      hint: 'getNftArguments',
    })
  })
  return {
    contractAddress,
    gasLimit,
    txInput,
  }
}
